import dayjs from 'dayjs';
export default (function (value, msg) {
  return dayjs(value).format(msg('date.format'));
});
export var getHoursAndMinutes = function getHoursAndMinutes(timestamp) {
  var date = dayjs(timestamp);
  return "".concat(date.hour(), ":").concat((date.minute() < 10 ? '0' : '') + date.minute());
};